<template>
  <div>
    <b-row v-if="!externalOpenItemToggle || (hasCourse && orderTypeId === 2 && !byCreateTab)" class="flex-grow-1 mt-1 mb-2 pb-2 justify-content-end" >
      <b-col v-if="!externalOpenItemToggle" cols="auto" class="d-flex align-items-center">
        <b-button
          class="open-item-toggle"
          :class="{ available: !showOpenItemChoices }"
          :variant="showOpenItemChoices ? 'warning' : 'light'"
          @click="toggleOpenItem"
        >
          Open Item
        </b-button>
      </b-col>

      <b-col
        sm="6"
        v-if="hasCourse && orderTypeId === 2 && !byCreateTab"
        
      >
        <b-btn
          variant="warning"
          block
          class="text-nowrap mb-2 mb-xl-0"
          :disabled="loading || modifierValidation || remainCount === '0' || noPrice"
          @click="addItemAndUpdateAddedItem"
        >
          <span v-if="loading">
            <font-awesome-icon spin icon="circle-notch" class="align-middle" />
          </span>
          <span v-else>
            Add Item & Confirm Status (Send to Kitchen)
          </span>
        </b-btn>
      </b-col>

      
    </b-row>
    <b-row class="mb-3">
      <b-col cols="12" class="pt-2" :style="{'background-color': '#eeeeee!important'}">
        <div style="position: relative;" class=" d-flex flex-row align-items-center justify-content-between mb-3" >
          <div v-if="menuTypes.length >= 7">
            <div class="scroll-reminder" style="position: absolute; right: 47.5%; bottom: -0.4rem; z-index: 10;
             display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 0.5rem;">
              <div 
                v-for="(dot, index) in scrollReminderDots" 
                :key="`scroll-dot-${index}`"
                class="scroll-dot" 
                :class="{ 
                  'scroll-dot-active': dot.active, 
                  'scroll-dot-inactive': !dot.active,
                  'scroll-dot-first': index === 0,
                  'scroll-dot-last': index === scrollReminderDots.length - 1
                }"
                style="transition: all 0.3s ease;"
                @click="scrollToMenuType(index)"
              >
              </div>
            </div>
          </div>
        <div class="menu-types" >
          <!-- Scroll reminder animation (shows if menuTypes length > 8) -->
          

          <!-- available food menu types -->
          <b-button-group class="groupsButtons menu-types-grid  mr-5 pl-3" size="sm">
            <b-button
              style="font-size: 1rem; width: 10rem; height:5rem;"
              v-for="(item, index) in FoodMenuTypes"
              :key="`itemId${index}`"
              class="py-1 px-3"
              @click="getCategories(item.MenuTypeID)"
              :disabled="item.disabled"
              :class="{
                unavailable: item.unAvailable && !item.checked,
                activeBtn: item.checked,
                disabled: item.disabled,
                available: !item.unAvailable && !item.checked,
                lastItem: item.LastItem,
                firstItem: item.FirstItem
              }"
            >
              <span v-if="item.MenuType != '' && item.ItemType === 'Food'"  class="d-block">
                {{ item.MenuType }}
              </span>
              <span v-else-if="item.MenuType != '' && item.ItemType === 'Drink'"  class="d-block menu-type-drinks" >
                {{ item.MenuType }}
              </span>
              <span v-else  class="d-block" id="menu-type-spacer">
                {{ item.MenuType }}
              </span>
              <span v-if="item.unAvailable && item.MenuType != ''" class="d-block font-weight-bold text-danger small" style="font-size: 100%!important;">
                <span v-if="orderTypeId === 1">
                  Not Served Now
                </span>
                <span v-else-if="orderTypeId === 2 && item.MenuType != ''">
                  Dine in Not Allowed
                </span>
              </span>
            </b-button>
          </b-button-group>

         

          <!-- available drink menu types -->
          <b-button-group class="groupsButtons menu-types-grid menu-types-drink-width" size="sm">
            <b-button
              style="font-size: 1rem; width: 10rem; height:5rem;"
              v-for="(item, index) in DrinkMenuTypes"
              :key="`itemId${index}`"
              class="py-1 px-3"
              @click="getCategories(item.MenuTypeID)"
              :disabled="item.disabled"
              :class="{
                unavailable: item.unAvailable && !item.checked,
                activeBtnDrink: item.checked,
                disabled: item.disabled,
                availableDrinks: !item.unAvailable && !item.checked,
                lastItem: item.LastItem,
                firstItem: item.FirstItem
              }"
            >
              <span v-if="item.MenuType != '' && item.ItemType === 'Food'"  class="d-block">
                {{ item.MenuType }}
              </span>
              <span v-else-if="item.MenuType != '' && item.ItemType === 'Drink'"  class="d-block menu-type-drinks" >
                {{ item.MenuType }}
              </span>
              <span v-else  class="d-block" id="menu-type-spacer">
                {{ item.MenuType }}
              </span>
              <span v-if="item.unAvailable && item.MenuType != ''" class="d-block font-weight-bold text-danger small" style="font-size: 100%!important;">
                <span v-if="orderTypeId === 1">
                  Not Served Now
                </span>
                <span v-else-if="orderTypeId === 2 && item.MenuType != ''">
                  Dine in Not Allowed
                </span>
              </span>
            </b-button>
          </b-button-group>
          <b-button-group class="groupsButtons menu-types-grid  mr-5 pl-3" size="sm">
            <b-button
              style="font-size: 1rem; width: 10rem; height:5rem;"
              v-for="(item, index) in UnavailableFoodMenuTypes"
              :key="`itemId${index}`"
              class="py-1 px-3"
              @click="getCategories(item.MenuTypeID)"
              :disabled="item.disabled"
              :class="{
                unavailable: item.unAvailable && !item.checked,
                activeBtn: item.checked,
                disabled: item.disabled,
                available: !item.unAvailable && !item.checked
              }"
            >
              <span v-if="item.MenuType != '' && item.ItemType === 'Food'"  class="d-block">
                {{ item.MenuType }}
              </span>
              <span v-else-if="item.MenuType != '' && item.ItemType === 'Drink'"  class="d-block menu-type-drinks" >
                {{ item.MenuType }}
              </span>
              <span v-else  class="d-block" id="menu-type-spacer">
                {{ item.MenuType }}
              </span>
              <span v-if="item.unAvailable && item.MenuType != ''" class="d-block font-weight-bold text-danger small" style="font-size: 100%!important;">
                <span v-if="orderTypeId === 1">
                  Not Served Now
                </span>
                <span v-else-if="orderTypeId === 2 && item.MenuType != ''">
                  Dine in Not Allowed
                </span>
              </span>
            </b-button>
          </b-button-group>
          <b-button-group class="groupsButtons menu-types-grid menu-types-drink-width" size="sm">
            <b-button
              style="font-size: 1rem; width: 10rem; height:5rem;"
              v-for="(item, index) in UnavailableDrinkMenuTypes"
              :key="`itemId${index}`"
              class="py-1 px-3"
              @click="getCategories(item.MenuTypeID)"
              :disabled="item.disabled"
              :class="{
                unavailable: item.unAvailable && !item.checked,
                activeBtnDrink: item.checked,
                disabled: item.disabled,
                availableDrinks: !item.unAvailable && !item.checked
              }"
            >
              <span v-if="item.MenuType != '' && item.ItemType === 'Food'"  class="d-block">
                {{ item.MenuType }}
              </span>
              <span v-else-if="item.MenuType != '' && item.ItemType === 'Drink'"  class="d-block menu-type-drinks" >
                {{ item.MenuType }}
              </span>
              <span v-else  class="d-block" id="menu-type-spacer">
                {{ item.MenuType }}
              </span>
              <span v-if="item.unAvailable && item.MenuType != ''" class="d-block font-weight-bold text-danger small" style="font-size: 100%!important;">
                <span v-if="orderTypeId === 1">
                  Not Served Now
                </span>
                <span v-else-if="orderTypeId === 2 && item.MenuType != ''">
                  Dine in Not Allowed
                </span>
              </span>
            </b-button>
          </b-button-group>

        </div>
        </div>
        

      </b-col>
       <hr style="width: 100%; margin:0.5rem 0; background-color: #78909c">
       <b-col v-if="showOpenItemChoices" cols="12" class="px-3 pt-2 pb-1">
         <div class="d-flex flex-row" style="gap: 0.5rem;">
           <b-button
             class="food-type-food-button open-choice-btn"
             :class="{ active: openItemButtonValue === 'foodOpen' }"
             @click="makeOpenItem('foodOpen')"
           >
             Food Open Item
           </b-button>
           <b-button
             class="open-choice-btn drink-open-choice"
             :class="{ active: openItemButtonValue === 'drinkOpen' }"
             :disabled="isSpecial && orderType === 'Pickup'"
             @click="makeOpenItem('drinkOpen')"
           >
             Drink Open Item
           </b-button>
         </div>
       </b-col>
       <b-col cols="12" class="m-0 p-0 remove-scroll-bar"  v-if="!isOpen && !showOpenItemChoices">
          
        
        <div class="categories-container overflow-auto mb-0 relative">
          <div v-if="categories.length > 10">
            <div class="scroll-reminder" style="position: absolute; right: 47.5%; bottom: 0.5rem; z-index: 10;
             display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 0.5rem;">
              <div 
                v-for="(dot, index) in categoryScrollReminderDots" 
                :key="`category-scroll-dot-${index}`"
                class="scroll-dot" 
                :class="{ 
                  'scroll-dot-active': dot.active, 
                  'scroll-dot-inactive': !dot.active,
                  'scroll-dot-first': index === 0,
                  'scroll-dot-last': index === categoryScrollReminderDots.length - 1
                }"
                style="transition: all 0.3s ease;"
                @click="scrollToCategory(index)"
              >
              </div>
            </div>
          </div>
          <b-button-group v-if="ItemType==='Drink'" class="groupsButtonsDrink" size="sm">
            <b-button
              style="height: 4rem; font-size: 1rem;border-radius: 25px!important; min-width: 120px; font-weight: bold; border: 2px solid black; background-color: #78909c;"
              :class="{activeDrinkBtn: item.selected, availableCategoryBtn: !item.selected}"
              v-for="(item, index) in categories"
              :key="`categories${index}`"
              @click="getAllFoods(item.CategoryID)"
              class="px-1 py-2 ml-1"
              :style="{fontSize: item.CategoryDESC.length > 15 ? '0.8rem' : '1rem'}"
            >
              {{ item.CategoryDESC }}
            </b-button>
          </b-button-group>
          <b-button-group v-else class="groupsButtons" size="sm">
            <b-button
              style="height: 4rem; font-size: 1rem;border-radius: 25px!important; min-width: 120px; font-weight: bold; border: 2px solid black; background-color: #78909c ;"
              :class="{activeBtn: item.selected, availableCategoryBtn: !item.selected}"
              v-for="(item, index) in categories"
              :key="`categories${index}`"
              @click="getAllFoods(item.CategoryID)"
              class="px-2 py-2 ml-1"
              :style="{fontSize: item.CategoryDESC.length > 15 ? '0.8rem' : '1rem'}"
            >
              {{ item.CategoryDESC }}
            </b-button>
          </b-button-group>
        </div>
        <hr style="width: 100%; margin: 2rem 0 0rem 0; background-color: #78909c">
        
      </b-col>
      <b-col cols="12" class="px-0" v-if="!isOpen">
        <div v-if="ItemType==='Drink'" class="food-items-wrapper">
          <div class="food-item-container mb-3 d-flex flex-row align-items-center overflow-auto " style="background: #B3E5FC; ">
            
            <b-button
              style="font-size: 0.9rem; min-width: 8rem; height: 4.5rem; width: fit-content;overflow: hidden;"
              v-for="(food, index) in foods"
              :key="`food${index}`"
              :disabled="food.PriceInfo == ' ' || food.PriceInfo == ''"
              @click="selectFood(food)"
              class="p-1 pl-2 m-1 d-flex flex-column align-items-start justify-content-center"
              :class="{
                activeBtnDrink: food.selected,
                available: !food.selected && food.IsAvailable,
                'unavailable-item': !food.selected && !food.IsAvailable,
                
              }"
            >
            <template v-if="food.name.length > 15">
              <p class="mb-0" :class="{ 'veggie-item-name': isVeggieOrVegan(food) }" style="font-size: 1rem; font-weight:bold !important;" >{{ pritifyName(food.name.slice(0, findNearestSpace(food.name, 15))) }}</p>
              <p class="m-0" :class="{ 'veggie-item-name': isVeggieOrVegan(food) }" style="font-weight:bold !important; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{ pritifyName(food.name.slice(findNearestSpace(food.name, 15))) }}</p>
            </template>
            <template v-else>
              <p class="mb-0" :class="{ 'veggie-item-name': isVeggieOrVegan(food) }" style="font-size: 1rem; font-weight:bold !important;">{{ food.name }}</p>
            </template>
            <template v-if="!food.IsAvailable">
              <p class="mb-0" style="font-weight:normal !important; align-self: start;font-size: 0.65rem;">{{ food.PriceInfo }}</p>
            </template>
            <template v-else>
              <p class="mb-0" style="font-weight:normal !important; align-self: start;">{{ food.PriceInfo}}</p>
            </template>
            </b-button>
          </div>
          <div
            v-if="foodScrollDots.length"
            class="scroll-reminder food-scroll-reminder"
          >
            <div
              v-for="(dot, index) in foodScrollDots"
              :key="`food-scroll-dot-${index}`"
              class="scroll-dot"
              :class="{
                'scroll-dot-active': dot.active,
                'scroll-dot-inactive': !dot.active,
                'scroll-dot-first': index === 0,
                'scroll-dot-last': index === foodScrollDots.length - 1
              }"
              @click="scrollToFoodDot(index)"
            ></div>
          </div>
        </div>
        <div v-if="ItemType==='Food'" class="food-items-wrapper">
          <div class="food-item-container  d-flex flex-row align-items-center overflow-auto " style="">
            
            <b-button
              style="font-size: 0.9rem; min-width: 8rem; height: 4.5rem; width: fit-content;overflow: hidden;"
              v-for="(food, index) in foods"
              :disabled="food.PriceInfo == ' ' || food.PriceInfo == ''"
              :key="`food${index}`"
              @click="selectFood(food)"
              class="p-1 pl-2 m-1 d-flex flex-column align-items-start justify-content-center"

              :class="{
                activeBtn: food.selected,
                available: !food.selected && food.IsAvailable,
                'unavailable-item': !food.selected && !food.IsAvailable,
              }"
            >
            <template v-if="food.name.length > 15">
              <div style="paddin-bottom: 0.5rem!important;">
                <p class="mb-0" :class="{ 'veggie-item-name': isVeggieOrVegan(food) }" style="font-size: 1rem; font-weight:bold !important;" >{{ pritifyName(food.name.slice(0, findNearestSpace(food.name, 15))) }}</p>
                <p class="m-0" :class="{ 'veggie-item-name': isVeggieOrVegan(food) }" style="font-size: 1rem; font-weight:bold !important; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{ pritifyName(food.name.slice(findNearestSpace(food.name, 15))) }}</p>
              </div>
            </template>
            <template v-else>
              <p class="mb-0" :class="{ 'veggie-item-name': isVeggieOrVegan(food) }" style="font-size: 1rem; font-weight:bold !important;">{{ food.name }}</p>
            </template>
            <template v-if="!food.IsAvailable">
              <p class="mb-0" style="font-weight:normal !important; align-self: start;font-size: 0.65rem;">{{ food.PriceInfo }}</p>
            </template>
            <template v-else>
              <p class="mb-0" style="font-weight:normal !important; align-self: start;">{{ food.PriceInfo}}</p>
            </template>
            </b-button>
          </div>
          <div
            v-if="foodScrollDots.length"
            class="scroll-reminder food-scroll-reminder"
          >
            <div
              v-for="(dot, index) in foodScrollDots"
              :key="`food-scroll-dot-${index}`"
              class="scroll-dot"
              :class="{
                'scroll-dot-active': dot.active,
                'scroll-dot-inactive': !dot.active,
                'scroll-dot-first': index === 0,
                'scroll-dot-last': index === foodScrollDots.length - 1
              }"
              @click="scrollToFoodDot(index)"
            ></div>
          </div>
        </div>
      </b-col>  
    </b-row>

    <b-row class="mb-3 pb-2" v-if="!isOpen && (priceTypes.length > 1 || modifiers.length)" style=" border-radius: 4px;" :style="{'background-color': backgroundColorContrast+'!important'}">
      <b-col cols="4" md="4" sm="4">
        <div v-if="itemTags.length" class="item-tags pt-2 px-2">
          <span
            v-for="tag in itemTags"
            :key="tag.text"
            class="item-tag"
            :style="{ backgroundColor: tag.bg, color: tag.color }"
          >
            {{ tag.text }}
          </span>
        </div>
        <div
          class="w-100 p-2"
          v-if="ItemCategory && priceTypes.length"
        >
          <h5 class="section-title mb-0">Price Selection</h5>
          <b-form-group class="mb-0">
            <b-form-radio-group
              stacked
              class="my-2"
              size="lg"
              id="radio-group-3"
              v-model="PriceType"
              name="Price"
            >
              <b-form-radio
                v-for="item in priceTypes"
                class="mb-3"
                :value="item.comment"
                :key="item.comment"
                button
                button-variant="outline-warning"
              >
                <span v-if="item.comment" class="font-weight-bold">
                  {{ item.comment }}
                </span>
                <span class="ml-3 text-muted">
                  ${{ item.value }}
                  <span v-if="item.value === 0" class="mx-2">
                    (FREE)
                  </span>
                </span>
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          <div v-if="this.ItemCategory.Alcoholic" class="h5 font-weight-bold mb-0" style="color: #4748cc">
            * Alcoholic: VERIFY AGE *
          </div>
        </div>
      </b-col>


      <b-col cols="8" sm="8">
        <div v-if="modifiers.length" class="p-2">
          <h5 class="section-title mb-2">Modifiers</h5>
          <div class="d-flex align-items-start" style="gap: 1rem;">
            <div class="modifier-groups-wrapper">
              <div class="modifier-groups-container" :class="{ 'modifier-groups-container-error': modifierErrorStatus }">
                <b-button
                  class="modifier-group-btn"
                  v-for="item in modifiers"
                  :class="{ activeBtn: item.selected, deactiveBtn: !item.selected, 'modifier-group-btn-error': item.hasError }"
                  @click="selectModifier(item)"
                  :key="item.ModifierCategory"
                >
                  <span :class="item.hasError ? 'error-btn-animated modifier-error-highlight' : 'text-dark'">
                    {{ item.ModifierCategory }}
                  </span>
                </b-button>
              </div>
              <div
                v-if="modifierGroupScrollDots.length"
                class="scroll-reminder modifier-groups-scroll-reminder"
              >
                <div
                  v-for="(dot, index) in modifierGroupScrollDots"
                  :key="`modifier-group-scroll-dot-${index}`"
                  class="scroll-dot"
                  :class="{
                    'scroll-dot-active': dot.active,
                    'scroll-dot-inactive': !dot.active,
                    'scroll-dot-first': index === 0,
                    'scroll-dot-last': index === modifierGroupScrollDots.length - 1
                  }"
                  @click="scrollToModifierGroupDot(index)"
                ></div>
              </div>
            </div>

            <div class="flex-grow-1" style="min-width: 0;">
              <div class="d-flex flex-wrap align-items-center mb-2" style="gap: 0.75rem;">
                <span style="color: rgba(0,0,71,0.82)">
                  <span v-if="activeModifier.IsOptional">Optional</span>
                  <span v-else>Required</span>
                  {{ ' ( ' + activeModifier.ChoiceOption + '  ' + activeModifier.ChoiceNumber + ' ) ' }}
                </span>
                <span v-if="activeModifier.errorText" class="modifier-error-text error-btn-animated">
                  {{ activeModifier.errorText }}
                </span>
              </div>
              <div class="modifier-options">
                <button
                  type="button"
                  v-for="item in activeModifier.ModifierItems"
                  :key="item.ModifierName"
                  class="modifier-option"
                  :class="{ checked: item.checked }"
                  @click="changeModifierOption(item, activeModifier)"
                >
                  <span class="modifier-option-check">
                    <font-awesome-icon v-if="item.checked" icon="check" />
                  </span>
                  <span class="modifier-option-text">
                    <span class="modifier-option-name">{{ item.ModifierName }}</span>
                    <span v-if="item.ModifierDesc !== ''" class="modifier-option-desc">{{ item.ModifierDesc }}</span>
                    <span v-if="Number(item.Price) > 0" class="modifier-option-price">{{ '+$' + Number(item.Price).toFixed(2) }}</span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </b-col>
  </b-row>
    
    <b-row class="mb-3">
      <b-col v-if="isOpen" cols="12" md="6" class="mb-5">
        <!-- <b-list-group class="mb-1">
          <b-list-group-item
            v-for="item in openItems"
            :key="item.ItemID"
            class="cursor-pointer"
            :active="item.active"
            @click="selectOpenItem(item)"
          >
            {{ item.ItemName }}
          </b-list-group-item>
        </b-list-group> -->
        <b-form-group class="mb-5" >
          <b-input-group :prepend="`Open ${openItemType} Name`">
            <b-input v-model="selectedOpenItemName" style="font-size: 1.1rem;" />
          </b-input-group>
        </b-form-group>
      <b-form-checkbox
        v-if="openItems.length > 1"
        v-model="isAlcoholicOpenItem"
        class="mb-2"
        size="lg"
        :style="{'color': backgroundColorContrast+'!important'}"
        @change="selectOpenItem(isAlcoholicOpenItem ? openItems[1] : openItems[0])"
      >
        <!-- use the order, first item is non-alcoholic, second item is alcoholic if changed this also has to change -->
        Alcoholic
      </b-form-checkbox>
      </b-col>
      <b-col v-if="isOpen" cols="12" md="6">
        <b-form-group class="mb-4">
          <b-input-group prepend="Unit Price($)" >
            <numeric-input no-seprator style="font-size: 1.1rem;" v-model="openItemUnitPrice" v-validate="'required'" name="unit price" />
          </b-input-group>  
        </b-form-group>

        <b-form-group class="mb-4">
          <b-input-group prepend="Display station" >
            <b-select v-model="KDS" :options="kdsList" v-validate="'required'" name="Display station" style="font-size: 1.1rem!important;" />
          </b-input-group>
        </b-form-group>

        <b-form-group v-if="showPrinterField" class="mb-4">
          <b-input-group prepend="Printstation" >
            <b-select
              v-model="PrinterID"
              :options="printers"
              style="font-size: 1.1rem;"
              text-field="PrinterName"
              value-field="PrinterID"
              name="Printstation"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6">
        <div v-if="hasCourse && orderTypeId === 2" class="d-flex align-items-center mb-3 flex-nowrap">
          <b-btn size="sm" variant="danger" @click="reduceCourse">
            <font-awesome-icon icon="minus" class="mx-1 align-middle" />
          </b-btn>
          <b-input-group class="mx-1" prepend="Course" style="font-size: 1.1rem;">
            <numeric-input no-seprator :decimal="false" v-model="CourseNo" name="Course" />
          </b-input-group>
          <b-btn size="sm" variant="danger" @click="addCourse">
            <font-awesome-icon icon="plus" class="mx-1 align-middle" />
          </b-btn>
        </div>

        <div class="d-flex align-items-center mb-3 flex-nowrap" v-if="showQuantityAndinstructions">
          <b-btn size="sm" variant="danger" @click="Quantity = Quantity - 1">
            <font-awesome-icon icon="minus" class="mx-1 align-middle" />
          </b-btn>
          <b-input-group class="mx-1" prepend="Quantity" style="font-size: 1.1rem;">
            <numeric-input no-seprator :decimal="false" v-model="Quantity" v-validate="quantityValidation" name="quantity" />
          </b-input-group>
          <b-btn size="sm" variant="danger" @click="Quantity = Quantity + 1">
            <font-awesome-icon icon="plus" class="mx-1 align-middle" />
          </b-btn>
        </div>

        <template v-if="!isOpen">
          <p class="mb-0 mt-3 text-danger font-weight-bold" v-if="remainCount !== ''" :style="{'color': backgroundColorContrast+'!important'}">
            <span v-if="remainCount == '0'">ZERO left</span>
            <span v-else> Only {{ remainCount }} Left </span>
          </p>
          <p v-if="modifierValidation" class="font-weight-bold mt-3 text-danger" :style="{'color': backgroundColorContrast+'!important'}">
            Please select the missing modifier(s).
          </p>
          <p v-if="noPrice" class="font-weight-bold mt-3 text-danger" :style="{'color': backgroundColorContrast+'!important'}">
            Item is not orderable due to missing price
          </p>
        </template>
      </b-col>
      <b-col cols="12" md="6">
        <b-input-group prepend="Special Instructions *" v-if="showQuantityAndinstructions" style="font-size: 1.1rem;">
          <b-textarea v-model="Description" />
        </b-input-group>
        <p v-if="(priceTypes.length > 1 || modifiers.length)" class="mt-1 text-danger" style="font-style: italic" :style="{'color': backgroundColorContrast+'!important'}">
          * Text input will be visible to customers.
        </p>
      </b-col>
    </b-row>
    <b-alert :show="errors.any()" variant="danger" class="px-4 my-2">
      <ul class="m-0 px-1">
        <li v-for="err in errors.all()" :key="err">{{ err }}</li>
      </ul>
    </b-alert>

    <b-row class="flex-grow-1 justify-content-center my-3" style="width: 100%;" v-if="showAddItemButton">
      <b-col sm="12" :xl="hasCourse && orderTypeId === 2 && !byCreateTab ? 4 : 6">
        <b-btn
          variant="warning"
          block
          size="lg"
          class="text-nowrap mb-2 mb-xl-0"
          style="width: 100%; opacity: 1!important;"
          :disabled="loading || modifierValidation || remainCount === '0' || noPrice"
          @click="addItem"
        >
          <span v-if="loading">
            <font-awesome-icon spin icon="circle-notch" class="align-middle" />
          </span>
          <span v-else>Add item</span>
        </b-btn>
      </b-col>

      <b-col
        sm="12" cols="12"
        v-if="hasCourse && orderTypeId === 2 && !byCreateTab"
        :xl="hasCourse && orderTypeId === 2 && !byCreateTab ? 4 : 6"
      >
        <b-btn
          variant="warning"
          block
          size="lg"
          class="text-nowrap mb-2 mb-xl-0"
          :disabled="loading || modifierValidation || remainCount === '0' || noPrice"
          @click="addItemAndUpdateAddedItem"
        >
          <span v-if="loading">
            <font-awesome-icon spin icon="circle-notch" class="align-middle" />
          </span>
          <span v-else>
            Add Item & Confirm Status (Send to Kitchen)
          </span>
        </b-btn>
      </b-col>

     
    </b-row>
  </div>
</template>
<script>
import Multiselect from '../shared/multiselect'
import NumericInput from '../shared/NumericInput'
export default {
  name: 'addItem',
  components: {
    Multiselect,
    NumericInput
  },
  props: {
    isSpecial: {
      type: Boolean,
      default: false
    },
    orderType: {required: false},
    orderTypeId: {type: [Number, String], default: ''},
    selectedItems: {required: false},
    currentTime: {required: false},
    specialMenuType: {required: false},
    selectedOrderID: {
      required: false
    },
    hasCourse: {
      type: Boolean,
      default: false
    },
    byCreateTab: {
      type: Boolean,
      default: false
    },
    externalOpenItemToggle: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: '#FFFFFF'
    },
    backgroundColorContrast: {
      type: String,
      default: '#000000'
    }
  },

  data() {
    return {
      CourseNo: '',
      openItemButtonValue: '',
      showOpenItemChoices: false,
      openItem: 'close',
      ItemType: 'Food',
      menuTypes: [],
      categories: [],
      categoryId: null,
      foods: [],
      ItemCategory: null,
      PriceType: null,
      remainCount: '',
      modifiers: [],
      kdsList: [],
      KDS: '',
      PrinterID: 0,
      printers: [],
      Quantity: 1,
      Description: '',
      loading: false,
      menuTypeId: '',
      openItemTypes: [
        {text: 'Open Item Alcoholic', value: 'Open Item Alcoholic'},
        {text: 'Open Item Non-Alcoholic', value: 'Open Item Non-Alcoholic'}
      ],
      openItemType: 'Open Item Alcoholic',
      openItemUnitPrice: '',
      openItems: [],
      OpenItemCategory: null,
      disableOpenDrinkButton:false,
      disableOpenFoodButton:false,
      openItemType:'',
      selectedCategoryID:null,
      categoriesCache: {},
      currentVisibleMenuTypeIndex: 0,
      scrollReminderDots: [],
      currentVisibleCategoryIndex: 0,
      categoryScrollReminderDots: [],
      currentVisibleFoodIndex: 0,
      foodScrollDots: [],
      currentVisibleModifierGroupIndex: 0,
      modifierGroupScrollDots: [],
      isAlcoholicOpenItem: true,
      selectedOpenItemName: '',
    }
  },
  watch: {
    showOpenItemChoices (val) {
      this.$emit('open-item-toggled', val)
    },
    'activeModifier.ModifierItems'() {
      this.$nextTick(() => {
        this.setupModifierGroupScrollListener()
      })
    },
    modifiers: {
      handler() {
        this.$nextTick(() => {
          this.setupModifierGroupScrollListener()
        })
      },
      deep: true
    },
    activeModifier() {
      this.$nextTick(() => {
        this.setupModifierGroupScrollListener()
      })
    },
    foods: {
      handler() {
        this.$nextTick(() => {
          this.setupFoodScrollListener()
        })
      },
      deep: true
    },
    ItemType() {
      this.$nextTick(() => {
        this.setupFoodScrollListener()
      })
    }
  },
  mounted() {
    this.getAllMenuTypes(this.ItemType)
    //this.GetRestaurantOpenItems()
    this.getDefaultCourseNumber(this.selectedItems)
    this.GetRestaurantKDSs({
      RestaurantID: this.$store.state.selectedRestaurantId,
      // UserID: localStorage.getItem('userID')
    })
    this.getPrinters({
      RestaurantID: this.$store.state.selectedRestaurantId,
      // UserID: localStorage.getItem('userID')
    })
    
    // Add scroll event listener after component is mounted
    this.$nextTick(() => {
      this.setupScrollListener()
      this.setupCategoryScrollListener()
      this.setupModifierGroupScrollListener()
      this.setupFoodScrollListener()
    })
  },
  
  beforeDestroy() {
    if(!this.$el){ 
      return
    }
    const menuTypesContainer = this.$el.querySelector('.menu-types')
    if (menuTypesContainer) {
      menuTypesContainer.removeEventListener('scroll', this.handleScroll)
    }
    
    const categoriesContainer = this.$el.querySelector('.categories-container')
    if (categoriesContainer) {
      categoriesContainer.removeEventListener('scroll', this.handleCategoryScroll)
    }
    const modifierGroupsContainer = this.$el.querySelector('.modifier-groups-container')
    if (modifierGroupsContainer) {
      modifierGroupsContainer.removeEventListener('scroll', this.handleModifierGroupScroll)
    }
    const foodContainer = this.$el.querySelector('.food-item-container')
    if (foodContainer) {
      foodContainer.removeEventListener('scroll', this.handleFoodScroll)
    }
  },
  computed: {
    showQuantityAndinstructions(){
      if(this.foods.find(food => food.selected) && (this.modifiers.length > 0 || this.foods.find(food => food.selected).Price1 != -1)){
        return true 
      }
      return false
    },
    showAddItemButton(){
      if(this.openItem !== ''){
        return true
      }
      if(this.foods.find(food => food.selected) && (this.modifiers.length > 0 || this.foods.find(food => food.selected).Price1 != -1)){
        return true 
      }
      return false
    },
    modifierErrorStatus(){
      return this.modifiers.some(i => i.hasError)
    },
    DrinkMenuTypes() {
      let list = this.menuTypes
        .filter(el => el.ItemType === 'Drink' && !el.unAvailable)
        .sort((a, b) => {
          const nameA = (a.MenuType || '').toUpperCase();
          const nameB = (b.MenuType || '').toUpperCase();
          if (nameA && nameB) {
            return nameA > nameB ? 1 : nameA < nameB ? -1 : 0;
          } else if (nameA) {
            return -1;
          } else if (nameB) {
            return 1;
          }
          return 0;
        });
        const lastFoodIndex = list.map(el => el.ItemType).lastIndexOf("Drink");
    
    const firstDrinkIndex = list.map(el => el.ItemType).indexOf("Drink");

    if (lastFoodIndex !== -1) {
      list[lastFoodIndex].LastItem = true;
    }
    if (firstDrinkIndex !== -1) {
      list[firstDrinkIndex].FirstItem = true;
    }
    return list;
    },
    FoodMenuTypes() {
      let list = this.menuTypes
        .filter(el => el.ItemType === 'Food' && !el.unAvailable)
        .sort((a, b) => {
          const nameA = (a.MenuType || '').toUpperCase();
          const nameB = (b.MenuType || '').toUpperCase();
          if (nameA && nameB) {
            return nameA > nameB ? 1 : nameA < nameB ? -1 : 0;
          } else if (nameA) {
            return -1;
          } else if (nameB) {
            return 1;
          }
          return 0;
        });
    // Filter out items with MenuType 'Catering' or 'Catering Menu'
    list = list.filter(
      el =>
        (el.MenuType || '').toUpperCase() !== 'CATERING' &&
        (el.MenuType || '').toUpperCase() !== 'CATERING MENU'
    );
    const lastFoodIndex = list.map(el => el.ItemType).lastIndexOf("Food");
    
    const firstDrinkIndex = list.map(el => el.ItemType).indexOf("Food");

    if (lastFoodIndex !== -1) {
      list[lastFoodIndex].LastItem = true;
    }
    if (firstDrinkIndex !== -1) {
      list[firstDrinkIndex].FirstItem = true;
    }
    return list;
    },
    UnavailableDrinkMenuTypes() {
      let list = this.menuTypes
        .filter(el => el.ItemType === 'Drink' && el.unAvailable)
        .sort((a, b) => {
          const nameA = (a.MenuType || '').toUpperCase();
          const nameB = (b.MenuType || '').toUpperCase();
          if (nameA && nameB) {
            return nameA > nameB ? 1 : nameA < nameB ? -1 : 0;
          } else if (nameA) {
            return -1;
          } else if (nameB) {
            return 1;
          }
          return 0;
        });
      if (list.length > 0) {
        list[list.length - 1].LastItem = true;
      }
      return list;
    },
    
    UnavailableFoodMenuTypes() {
      let list  = this.menuTypes

      list = list.filter(el => el.ItemType === 'Food' && el.unAvailable)
        .sort((a, b) => {
          const nameA = (a.MenuType || '').toUpperCase();
          const nameB = (b.MenuType || '').toUpperCase();
          if (nameA && nameB) {
            return nameA > nameB ? 1 : nameA < nameB ? -1 : 0;
          } else if (nameA) {
            return -1;
          } else if (nameB) {
            return 1;
          }
          return 0;
        });

      // Find Catering or Catering Menu, remove from list, and unshift to beginning if exists
      const cateringIndex = this.menuTypes.findIndex(
        el => (el.MenuType || '').toUpperCase() === 'CATERING' || (el.MenuType || '').toUpperCase() === 'CATERING MENU'
      );
      if(cateringIndex > -1){
        list.unshift(this.menuTypes[cateringIndex]);
      }

      return list;
    },
    showPrinterField() {
      if(this.printers.length === 2){//consider index 0 in none option 
        this.PrinterID = this.printers[1].PrinterID
      }
      return this.printers.length === 1 ? false : true
    },
    isOpen() {
      return this.openItem === 'open' || this.openItem === 'open'
    },
    quantityValidation() {
      if (this.remainCount === '') {
        return {
          required: true,
          min_value: 1
        }
      } else if (this.remainCount == '0') {
        return {}
      } else {
        return {
          required: true,
          max_value: this.remainCount,
          min_value: 1
        }
      }
    },
    priceTypes() {
      return this.ItemCategory ? this.ItemCategory.availablePrices.filter(i => i.value >= 0) : []
    },
    noPrice() {
      if (this.ItemCategory && this.ItemCategory.Price < 0) return true
      return false
    },
    activeModifier() {
      return this.modifiers.find(item => item.selected)
    },
    modifierValidation() {
      if (!this.modifiers.length) {
        return false
      } else {
        return this.modifiers.some(i => i.hasError)
      }
    },
    itemTags() {
      const food = this.ItemCategory
      if (!food) return []
      const tags = [
        {text: 'Vegan', has: food.Vegan, bg: '#2E7D32', color: '#FFFFFF'},
        {text: 'Vegan Upon Request', has: food.VeganRequest, bg: '#E8F5E9', color: '#2E7D32'},
        {text: 'Veggie', has: food.Vegeterian || food.Vegetarian, bg: '#AED581', color: '#185E20'},
        {text: 'Veggie Upon Request', has: food.VegeterianRequest, bg: '#F1F8E9', color: '#558B2F'},
        {text: 'Gluten Free', has: food.GlutenFree, bg: '#D4E157', color: '#4E342E'},
        {text: 'Gluten Free Upon Request', has: food.GlutenFreeRequest, bg: '#E0F2F1', color: '#00695C'},
        {text: 'Dairy Free', has: food.DairyFree, bg: '#2196F3', color: '#FFFFFF'},
        {text: 'Kosher', has: food.Kosher, bg: '#29999A', color: '#FFFFFF'},
        {text: 'Halal Meat', has: food.Halal, bg: '#448042', color: '#FFFFFF'},
        {text: 'Hot/Spicy', has: food.Hot, bg: '#D32F2F', color: '#FFFFFF'},
        {text: 'Hot/Spicy Upon Request', has: food.HotRequest, bg: '#FFEBEE', color: '#C62828'},
        {text: 'Raw/Undercooked', has: food.Uncooked, bg: '#EC407A', color: '#FFFFFF'},
      ]
      return tags.filter(tag => tag.has)
    }
  },
  methods: {
    findNearestSpace(name, index) {
      let temp = name.slice(0, index)
      let spaceIndex = temp.lastIndexOf(' ')
      return spaceIndex !== -1 ? spaceIndex : temp.length
    },
    pritifyName(name) {
      return name.length > 30 ? name.slice(0, 30) + '...' : name
    },
    isVeggieOrVegan(food) {
      return !!(food && (food.Vegan || food.Vegeterian || food.Vegetarian))
    },
    setupScrollListener() {
      if(!this.$el){ 
        return
      }
      const menuTypesContainer = this.$el.querySelector('.menu-types')
      if (menuTypesContainer) {
        menuTypesContainer.addEventListener('scroll', this.handleScroll)
        // Initialize scroll reminder dots
        this.updateScrollReminderDots()
      }
    },
    setupModifierGroupScrollListener() {
      if (!this.$el) {
        return
      }
      const modifierGroupsContainer = this.$el.querySelector('.modifier-groups-container')
      if (!modifierGroupsContainer) {
        this.modifierGroupScrollDots = []
        return
      }
      modifierGroupsContainer.removeEventListener('scroll', this.handleModifierGroupScroll)
      modifierGroupsContainer.addEventListener('scroll', this.handleModifierGroupScroll)
      this.handleModifierGroupScroll({ target: modifierGroupsContainer })
    },
    handleModifierGroupScroll(event) {
      const container = event && event.target ? event.target : null
      if (!container) {
        this.currentVisibleModifierGroupIndex = 0
        this.updateModifierGroupScrollDots()
        return
      }
      const totalModifiers = this.modifiers.length
      let totalDots = 0
      if (totalModifiers > 8) {
        totalDots = 3
      } else if (totalModifiers > 4) {
        totalDots = 2
      }
      if (totalDots === 0) {
        this.currentVisibleModifierGroupIndex = 0
        this.modifierGroupScrollDots = []
        return
      }
      const maxScroll = container.scrollHeight - container.clientHeight
      let activeIndex = 0
      if (maxScroll > 0) {
        const scrollPercentage = container.scrollTop / maxScroll
        if (totalDots === 3) {
          if (scrollPercentage < 0.33) {
            activeIndex = 0
          } else if (scrollPercentage > 0.67) {
            activeIndex = 2
          } else {
            activeIndex = 1
          }
        } else {
          activeIndex = scrollPercentage < 0.5 ? 0 : 1
        }
      }
      this.currentVisibleModifierGroupIndex = activeIndex
      this.updateModifierGroupScrollDots()
    },
    updateModifierGroupScrollDots() {
      const totalModifiers = this.modifiers.length
      let totalDots = 0
      if (totalModifiers > 8) {
        totalDots = 3
      } else if (totalModifiers > 4) {
        totalDots = 2
      }
      if (totalDots === 0) {
        this.modifierGroupScrollDots = []
        return
      }
      const activeIndex = Math.min(this.currentVisibleModifierGroupIndex, totalDots - 1)
      this.modifierGroupScrollDots = Array.from({ length: totalDots }, (_, index) => ({
        index,
        active: index === activeIndex
      }))
    },
    scrollToModifierGroupDot(dotIndex) {
      if (!this.$el) {
        return
      }
      const container = this.$el.querySelector('.modifier-groups-container')
      if (!container) {
        return
      }
      const totalModifiers = this.modifiers.length
      let totalDots = 0
      if (totalModifiers > 8) {
        totalDots = 3
      } else if (totalModifiers > 4) {
        totalDots = 2
      }
      if (totalDots === 0) {
        return
      }
      const maxScroll = container.scrollHeight - container.clientHeight
      let targetScroll = 0
      if (totalDots === 3) {
        if (dotIndex === 0) {
          targetScroll = 0
        } else if (dotIndex === 1) {
          targetScroll = maxScroll / 2
        } else {
          targetScroll = maxScroll
        }
      } else {
        targetScroll = dotIndex === 0 ? 0 : maxScroll
      }
      container.scrollTo({
        top: targetScroll,
        behavior: 'smooth'
      })
      setTimeout(() => {
        this.handleModifierGroupScroll({ target: container })
      }, 600)
    },
    setupFoodScrollListener() {
      if (!this.$el) {
        return
      }
      const foodContainer = this.$el.querySelector('.food-item-container')
      if (!foodContainer) {
        this.foodScrollDots = []
        return
      }
      foodContainer.removeEventListener('scroll', this.handleFoodScroll)
      foodContainer.addEventListener('scroll', this.handleFoodScroll)
      this.handleFoodScroll({ target: foodContainer })
    },
    handleFoodScroll(event) {
      const container = event && event.target ? event.target : null
      if (!container) {
        this.currentVisibleFoodIndex = 0
        this.updateFoodScrollDots()
        return
      }
      const totalFoods = this.foods.length
      let totalDots = 0
      if (totalFoods > 15) {
        totalDots = 3
      } else if (totalFoods >= 9) {
        totalDots = 2
      }
      if (totalDots === 0) {
        this.currentVisibleFoodIndex = 0
        this.foodScrollDots = []
        return
      }
      const maxScroll = container.scrollWidth - container.clientWidth
      let activeIndex = 0
      if (maxScroll > 0) {
        const scrollPercentage = container.scrollLeft / maxScroll
        if (totalDots === 3) {
          if (scrollPercentage < 0.33) {
            activeIndex = 0
          } else if (scrollPercentage > 0.67) {
            activeIndex = 2
          } else {
            activeIndex = 1
          }
        } else {
          activeIndex = scrollPercentage < 0.5 ? 0 : 1
        }
      }
      this.currentVisibleFoodIndex = activeIndex
      this.updateFoodScrollDots()
    },
    updateFoodScrollDots() {
      const totalFoods = this.foods.length
      let totalDots = 0
      if (totalFoods > 15) {
        totalDots = 3
      } else if (totalFoods >= 9) {
        totalDots = 2
      }
      if (totalDots === 0) {
        this.foodScrollDots = []
        return
      }
      const activeIndex = Math.min(this.currentVisibleFoodIndex, totalDots - 1)
      this.foodScrollDots = Array.from({ length: totalDots }, (_, index) => ({
        index,
        active: index === activeIndex
      }))
    },
    scrollToFoodDot(dotIndex) {
      if (!this.$el) {
        return
      }
      const container = this.$el.querySelector('.food-item-container')
      if (!container) {
        return
      }
      const totalFoods = this.foods.length
      let totalDots = 0
      if (totalFoods > 15) {
        totalDots = 3
      } else if (totalFoods >= 9) {
        totalDots = 2
      }
      if (totalDots === 0) {
        return
      }
      const maxScroll = container.scrollWidth - container.clientWidth
      let targetScroll = 0
      if (totalDots === 3) {
        if (dotIndex === 0) {
          targetScroll = 0
        } else if (dotIndex === 1) {
          targetScroll = maxScroll / 2
        } else {
          targetScroll = maxScroll
        }
      } else {
        targetScroll = dotIndex === 0 ? 0 : maxScroll
      }
      container.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      })
      setTimeout(() => {
        this.handleFoodScroll({ target: container })
      }, 600)
    },
    
    handleScroll(event) {//for menu types
      const container = event.target  
      const scrollLeft = container.scrollLeft
      const containerWidth = container.clientWidth
      const scrollWidth = container.scrollWidth
      
      // Check if we're at the end of scroll (with tolerance for floating point precision)
      const maxScroll = scrollWidth - containerWidth
      const isAtEnd = scrollLeft >= maxScroll - 10
      const isAtStart = scrollLeft <= 10
      
      if(!container){ 
        return
      }
      // Get all menu type buttons from all button groups
      const menuTypeButtons = container.querySelectorAll('.groupsButtons button')
      
      // Determine which dot section we're in based on scroll percentage
      let mostVisibleIndex = 0
      if (maxScroll > 0 && menuTypeButtons.length > 0) {
        const scrollPercentage = scrollLeft / maxScroll
        const totalMenuTypes = this.menuTypes.length
        const maxVisibleDots = totalMenuTypes <= 10 ? 2 : 3
        
        if (maxVisibleDots === 3) {
          // For 3 dots, divide into thirds based on scroll percentage
          if (isAtStart || scrollPercentage < 0.33) {
            // First third - first dot
            mostVisibleIndex = 0
          } else if (isAtEnd || scrollPercentage > 0.67) {
            // Last third - last dot
            mostVisibleIndex = menuTypeButtons.length - 1
          } else {
            // Middle third - middle dot
            // Use the button closest to the middle position
            mostVisibleIndex = Math.floor(menuTypeButtons.length / 2)
          }
        } else {
          // For 2 dots, divide into halves
          if (isAtStart || scrollPercentage < 0.5) {
            mostVisibleIndex = 0
          } else {
            mostVisibleIndex = menuTypeButtons.length - 1
          }
        }
      }
      
      this.currentVisibleMenuTypeIndex = mostVisibleIndex
      this.updateScrollReminderDots()
    },
    
    updateScrollReminderDots() {
      // Get the actual number of menu type buttons
      const container = this.$el && this.$el.querySelector('.menu-types')
      const menuTypeButtons = container ? container.querySelectorAll('.groupsButtons button') : []
      const actualButtonCount = menuTypeButtons.length
      
      // Calculate how many dots we need based on total menu types
      const totalMenuTypes = this.menuTypes.length
      
      let maxVisibleDots
      if (totalMenuTypes <= 10) {
        maxVisibleDots = 2 // Show only 2 dots for 10 or fewer menu types
      } else {
        maxVisibleDots = 3 // Show 3 dots for more than 10 menu types
      }
      
      if (actualButtonCount <= maxVisibleDots) {
        // If total buttons is less than or equal to max dots, show all
        this.scrollReminderDots = Array.from({ length: actualButtonCount }, (_, index) => ({
          index,
          active: index === this.currentVisibleMenuTypeIndex
        }))
      } else {
        // Calculate which dots to show based on current position
        const totalDots = maxVisibleDots
        const currentPosition = this.currentVisibleMenuTypeIndex
        const totalPositions = actualButtonCount
        
        // Also check scroll percentage for more accurate dot activation
        let activeDotIndex
        if (container) {
          const scrollLeft = container.scrollLeft
          const scrollWidth = container.scrollWidth
          const clientWidth = container.clientWidth
          const maxScroll = scrollWidth - clientWidth
          
          if (maxScroll > 0) {
            const scrollPercentage = scrollLeft / maxScroll
            
            if (totalDots === 3) {
              // For 3 dots, use scroll percentage to determine active dot
              if (scrollPercentage < 0.33) {
                activeDotIndex = 0 // First third
              } else if (scrollPercentage > 0.67) {
                activeDotIndex = 2 // Last third
              } else {
                activeDotIndex = 1 // Middle third
              }
            } else {
              // For 2 dots
              if (scrollPercentage < 0.5) {
                activeDotIndex = 0
              } else {
                activeDotIndex = 1
              }
            }
          } else {
            // Fallback to button-based calculation
            if (currentPosition >= totalPositions - 1) {
              activeDotIndex = totalDots - 1
            } else if (currentPosition === 0) {
              activeDotIndex = 0
            } else {
              activeDotIndex = Math.floor((currentPosition / (totalPositions - 1)) * (totalDots - 1))
            }
          }
        } else {
          // Fallback to button-based calculation
          if (currentPosition >= totalPositions - 1) {
            activeDotIndex = totalDots - 1
          } else if (currentPosition === 0) {
            activeDotIndex = 0
          } else {
            activeDotIndex = Math.floor((currentPosition / (totalPositions - 1)) * (totalDots - 1))
          }
        }
        
        this.scrollReminderDots = Array.from({ length: totalDots }, (_, index) => ({
          index,
          active: index === activeDotIndex
        }))
      }
    },
    scrollToMenuType(dotIndex) {
      if(!this.$el){ 
        return
      }
      const container = this.$el.querySelector('.menu-types')
      if (!container) return
      const menuTypeButtons = container.querySelectorAll('.groupsButtons button')
      if (menuTypeButtons.length === 0) return
      const totalMenuTypes = this.menuTypes.length 
      let maxVisibleDots
      if (totalMenuTypes <= 10) {
        maxVisibleDots = 2 // Show only 2 dots for 10 or fewer menu types
      } else {
        maxVisibleDots = 3 // Show 3 dots for more than 10 menu types
      }
      
      let targetIndex
      if (totalMenuTypes <= maxVisibleDots) {
        // If total menu types is less than or equal to max dots, use dot index directly
        targetIndex = dotIndex
      } else {
        // Calculate which menu type to scroll to based on dot index
        const totalDots = maxVisibleDots
        const totalPositions = totalMenuTypes
        if (dotIndex === 0) {
          // First dot - scroll to beginning
          targetIndex = 0
        } else if (dotIndex === totalDots - 1) {
          // Last dot - scroll to end
          targetIndex = totalPositions - 1
        } else {
          // Middle dots - calculate proportionally
          targetIndex = Math.floor((dotIndex / (totalDots - 1)) * (totalPositions - 1))
        }
      }
      
      // Ensure target index is within bounds
      targetIndex = Math.min(targetIndex, menuTypeButtons.length - 1)
      
      // Scroll to the target button
      const targetButton = menuTypeButtons[targetIndex]
      if (targetButton) {
        // If scrolling to the last dot, scroll to the very end of the container
        if (dotIndex === maxVisibleDots - 1 && totalMenuTypes > maxVisibleDots) {
          const maxScroll = container.scrollWidth - container.clientWidth
          container.scrollTo({
            left: maxScroll,
            behavior: 'smooth'
          })
        } else if (maxVisibleDots === 3 && dotIndex === 1) {
          // Middle dot for 3 dots - scroll to middle position
          const maxScroll = container.scrollWidth - container.clientWidth
          const middleScroll = maxScroll / 2
          container.scrollTo({
            left: middleScroll,
            behavior: 'smooth'
          })
          // Update after scroll completes
          setTimeout(() => {
            this.handleScroll({ target: container })
          }, 600)
        } else {
          const containerRect = container.getBoundingClientRect()
          const buttonRect = targetButton.getBoundingClientRect()
          
          // Calculate scroll position to center the button
          const scrollLeft = container.scrollLeft + (buttonRect.left - containerRect.left) - (containerRect.width / 2) + (buttonRect.width / 2)
          
          // Smooth scroll to the target position
          container.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          })
        }
      }
    },
    
    setupCategoryScrollListener() {
      const categoriesContainer = this.$el && this.$el.querySelector('.categories-container')
      if (categoriesContainer) {
        // Remove existing listener if any to prevent duplicates
        categoriesContainer.removeEventListener('scroll', this.handleCategoryScroll)
        // Add scroll event listener
        categoriesContainer.addEventListener('scroll', this.handleCategoryScroll)
        // Initialize category scroll reminder dots
        this.updateCategoryScrollReminderDots()
      }
    },
    
    handleCategoryScroll(event) {
      const container = event.target
      const scrollLeft = container.scrollLeft
      const containerWidth = container.clientWidth
      const scrollWidth = container.scrollWidth
      
      // Check if we're at the end or start of scroll
      const maxScroll = scrollWidth - containerWidth
      const isAtEnd = scrollLeft >= maxScroll - 10
      const isAtStart = scrollLeft <= 10
      
      // Get all category buttons from both button groups
      const categoryButtons = container.querySelectorAll('.groupsButtons button, .groupsButtonsDrink button')
      
      // Determine which dot section we're in based on scroll percentage
      let mostVisibleIndex = 0
      if (maxScroll > 0 && categoryButtons.length > 0) {
        const scrollPercentage = scrollLeft / maxScroll
        const totalCategories = this.categories.length
        let maxVisibleDots
        if (totalCategories > 14) {
          maxVisibleDots = 3 // Show 3 dots for more than 14 categories
        } else if (totalCategories > 10) {
          maxVisibleDots = 2 // Show 2 dots for more than 10 but less than or equal to 14 categories
        } else {
          maxVisibleDots = 0
        }
        
        if (maxVisibleDots === 3) {
          // For 3 dots, divide into thirds based on scroll percentage
          if (isAtStart || scrollPercentage < 0.33) {
            // First third - first dot
            mostVisibleIndex = 0
          } else if (isAtEnd || scrollPercentage > 0.67) {
            // Last third - last dot
            mostVisibleIndex = categoryButtons.length - 1
          } else {
            // Middle third - middle dot
            // Use the button closest to the middle position
            mostVisibleIndex = Math.floor(categoryButtons.length / 2)
          }
        } else if (maxVisibleDots === 2) {
          // For 2 dots, divide into halves
          if (isAtStart || scrollPercentage < 0.5) {
            mostVisibleIndex = 0
          } else {
            mostVisibleIndex = categoryButtons.length - 1
          }
        }
      }
      
      this.currentVisibleCategoryIndex = mostVisibleIndex
      this.updateCategoryScrollReminderDots()
    },
    
    updateCategoryScrollReminderDots() {
      // Calculate how many dots we need based on total categories
      if(!this.$el){ 
        return
      }
      const totalCategories = this.categories.length
      
      let maxVisibleDots
      
      if (totalCategories > 14) {
        maxVisibleDots = 3 // Show 2 dots for more than 14 categories
      } else if (totalCategories > 10) {
        maxVisibleDots = 2 // Show 1 dot for more than 10 but less than or equal to 14 categories
      } else {
        // Don't show dots for 10 or fewer categories (handled by v-if in template)
        this.categoryScrollReminderDots = []
        return
      }
      
      // Calculate which dots to show based on current position
      const totalDots = maxVisibleDots
      const currentPosition = this.currentVisibleCategoryIndex
      const totalPositions = totalCategories
      
      // Also check scroll percentage for more accurate dot activation
      
      const container = this.$el && this.$el.querySelector('.categories-container')
      let activeDotIndex
      
      if (maxVisibleDots === 1) {
        // For 1 dot, activate when at or near the end (last 30% of scroll)
        if (container) {
          const scrollLeft = container.scrollLeft
          const scrollWidth = container.scrollWidth
          const clientWidth = container.clientWidth
          const maxScroll = scrollWidth - clientWidth
          if (maxScroll > 0) {
            const scrollPercentage = scrollLeft / maxScroll
            if (scrollPercentage >= 0.7) {
              activeDotIndex = 0
            } else {
              activeDotIndex = -1
            }
          } else {
            activeDotIndex = currentPosition >= totalPositions - 1 ? 0 : -1
          }
        } else {
          const scrollPercentage = totalPositions > 1 ? currentPosition / (totalPositions - 1) : 0
          activeDotIndex = scrollPercentage >= 0.7 || currentPosition >= totalPositions - 1 ? 0 : -1
        }
      } else {
        // For 2 or 3 dots, use scroll percentage
        if (container) {
          const scrollLeft = container.scrollLeft
          const scrollWidth = container.scrollWidth
          const clientWidth = container.clientWidth
          const maxScroll = scrollWidth - clientWidth
          
          if (maxScroll > 0) {
            const scrollPercentage = scrollLeft / maxScroll
            
            if (totalDots === 3) {
              // For 3 dots, use scroll percentage to determine active dot
              if (scrollPercentage < 0.33) {
                activeDotIndex = 0 // First third
              } else if (scrollPercentage > 0.67) {
                activeDotIndex = 2 // Last third
              } else {
                activeDotIndex = 1 // Middle third
              }
            } else {
              // For 2 dots
              if (scrollPercentage < 0.5) {
                activeDotIndex = 0
              } else {
                activeDotIndex = 1
              }
            }
          } else {
            // Fallback to button-based calculation
            if (currentPosition >= totalPositions - 1) {
              activeDotIndex = totalDots - 1
            } else if (currentPosition === 0) {
              activeDotIndex = 0
            } else {
              activeDotIndex = Math.floor((currentPosition / (totalPositions - 1)) * (totalDots - 1))
            }
          }
        } else {
          // Fallback to button-based calculation
          if (currentPosition >= totalPositions - 1) {
            activeDotIndex = totalDots - 1
          } else if (currentPosition === 0) {
            activeDotIndex = 0
          } else {
            if (totalDots === 3) {
              const third = (totalPositions - 1) / 3
              if (currentPosition <= third) {
                activeDotIndex = 0
              } else if (currentPosition <= third * 2) {
                activeDotIndex = 1
              } else {
                activeDotIndex = 2
              }
            } else {
              activeDotIndex = Math.floor((currentPosition / (totalPositions - 1)) * (totalDots - 1))
            }
          }
        }
      }
      
      this.categoryScrollReminderDots = Array.from({ length: totalDots }, (_, index) => ({
        index,
        active: index === activeDotIndex
      }))
    },
    
    scrollToCategory(dotIndex) {
      const container = this.$el.querySelector('.categories-container')
      if (!container) return
      const categoryButtons = container.querySelectorAll('.groupsButtons button, .groupsButtonsDrink button')
      if (categoryButtons.length === 0) return
      
      const totalCategories = this.categories.length
      
      let maxVisibleDots
      if (totalCategories > 14) {
        maxVisibleDots = 3 // Show 3 dots for more than 14 categories
      } else if (totalCategories > 10) {
        maxVisibleDots = 2 // Show 2 dots for more than 10 but less than or equal to 14 categories
      } else {
        // Don't show dots for 10 or fewer categories
        return
      }
      
      // Handle scrolling based on dot count
      if (maxVisibleDots === 2 && totalCategories <= 14) {
        // For 2 dots (10 < categories <= 14)
        if (dotIndex === 0) {
          // First dot - scroll to beginning
          container.scrollTo({
            left: 0,
            behavior: 'smooth'
          })
        } else if (dotIndex === 1) {
          // Second dot - scroll to end
          const maxScroll = container.scrollWidth - container.clientWidth
          container.scrollTo({
            left: maxScroll,
            behavior: 'smooth'
          })
        }
      } else if (maxVisibleDots === 3) {
        // For 3 dots (categories > 14)
        const totalPositions = totalCategories
        
        if (dotIndex === 0) {
          // First dot - scroll to beginning
          container.scrollTo({
            left: 0,
            behavior: 'smooth'
          })
        } else if (dotIndex === 2) {
          // Last dot - scroll to end
          const maxScroll = container.scrollWidth - container.clientWidth
          container.scrollTo({
            left: maxScroll,
            behavior: 'smooth'
          })
        } else if (dotIndex === 1) {
          // Middle dot - scroll to middle position
          const maxScroll = container.scrollWidth - container.clientWidth
          const middleScroll = maxScroll / 2
          container.scrollTo({
            left: middleScroll,
            behavior: 'smooth'
          })
          // Update after scroll completes
          setTimeout(() => {
            this.handleScroll({ target: container })
          }, 600)
        }
      }
    },
   
    GetRestaurantKDSs(object) {
      this.$api.getRestaurant.GetRestaurantKDSs(object).then(res => {
        if (res.success) {
          res.results.RestaurantKDS.forEach(item => {
            item.value = item.KDSID
            item.text = item.KDS
          })
          const list = res.results.RestaurantKDS
          this.kdsList = list
          if (list.length) {
            this.KDS = res.results.RestaurantKDS[0].KDSID
          } else {
            this.KDS = ''
          }
        }
      })
    },
    getPrinters(object) {
      this.$api.getRestaurant.GetRestaurantPrinters(object).then(res => {
        if (res.success) {
          this.printers = [{PrinterName: 'None', PrinterID: 0}].concat(
            res.results.RestaurantPrinter.filter(i => i.PrintTaskID !== 2)
          )
          if (this.printers.length) {
            this.PrinterID = this.printers[0].PrinterID
          } else {
            this.PrinterID = 0
          }
        }
      })
    },
    reduceCourse() {
      if (this.CourseNo >= 1) {
        this.CourseNo = this.CourseNo - 1
        if (this.CourseNo === 0) {
          this.CourseNo = ''
        }
      }
      // if (this.CourseNo > 1) {
      //     this.CourseNo = this.CourseNo - 1
      //     if (this.CourseNo === 1) {
      //         this.CourseNo = ''
      //     }
      // }
    },
    addCourse() {
      if (this.CourseNo === '') {
        this.CourseNo = 1
      } else {
        this.CourseNo = this.CourseNo + 1
      }
    },
    getDefaultCourseNumber(items) {
      if (this.orderTypeId === 2) {
        if (this.byCreateTab) {
          if (this.selectedItems.length) {
            const lastItem = this.selectedItems[this.selectedItems.length - 1]
            const course = lastItem.CourseNo.split('C')[1]
            this.CourseNo = course
          } else {
            this.CourseNo = ''
          }
        } else {
          const activeItems = items
            .filter(item => item.OrderStatus !== 4 && item.Course)
            .map(item => +item.Course.split('C')[1])
            .sort()
          if (activeItems.length) {
            const min = activeItems[0]
            this.CourseNo = min
          } else {
            this.CourseNo = ''
          }
        }
      } else {
        this.CourseNo = ''
      }
    },
    GetRestaurantOpenItems(item) {
      const filter = {
        ItemType : item,
        RestaurantID: this.$store.state.selectedRestaurantId,
      }
      this.$api.getRestaurant.GetRestaurantOpenItems(filter).then(res => {
        if (res.success) {
          res.OpenItems.forEach((item, index) => {
            item.value = item.ItemID
            item.name = item.ItemName
            item.active = false
            if (index === 0) {
              item.active = true
            }
          })
          this.OpenItemCategory = res.OpenItems[0]
          this.openItems = res.OpenItems
        }
      })
      
      
    },
    selectOpenItem(item) {
      this.openItems.forEach(i => {
        i.active = false
        if (i.ItemID === item.ItemID) {
          i.active = true
        }
      })
      this.OpenItemCategory = item
    },
    
    toggleOpenItem() {
      if (this.showOpenItemChoices) {
        this.showOpenItemChoices = false
        this.openItem = 'close'
        this.openItemType = ''
        this.openItemButtonValue = ''
        return
      }
      const selectedMenu = this.menuTypes.find(i => i.checked)
      const selectedItemType = selectedMenu ? selectedMenu.ItemType : ''
      this.showOpenItemChoices = true
      this.openItem = 'close'
      this.openItemType = ''
      this.openItemButtonValue = ''
      this.menuTypeId = ''
      this.categories = []
      this.foods = []
      this.menuTypes.forEach(i => {
        i.checked = false
      })
      if (selectedItemType === 'Drink' && !(this.isSpecial && this.orderType === 'Pickup')) {
        this.makeOpenItem('drinkOpen')
      } else if (selectedItemType === 'Food') {
        this.makeOpenItem('foodOpen')
      }
    },
    makeOpenItem(openItemType){
      this.openItemButtonValue = openItemType
      if(openItemType === "drinkOpen"){
        this.openItem = 'open'
        this.openItemType = 'Drink'
        this.menuTypeId = ""
        this.GetRestaurantOpenItems("Drink")
      }else if (openItemType === "foodOpen" ){
        this.openItem = 'open'
        this.openItemType = 'Food'
        this.menuTypeId = ""
        this.GetRestaurantOpenItems("Food")
      }else{
        this.openItem = 'close'
        this.openItemType = ''
      }

    },
    
    getAllMenuTypes(ItemType) {
      this.menuTypeId = ''
      const model = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID'),
        ItemType,
        OrderTypeID: this.orderTypeId,
        currentTime: this.currentTime
      }
      this.$api.getRestaurant
        .GetRestaurantMenuTypes(model)
        .then(res => {
          if (res.success) {
            this.foods = []
            this.food = null
            this.PriceType = null
            this.ItemCategory = null
            this.menuTypes = res.results.RestaurantMenuTypeAll.filter(item => item.CanMenuTypeBeShown)
            this.menuTypes.forEach((item, index) => {
              if (this.specialMenuType) {
                if (item.MenuTypeID === this.specialMenuType) {
                  item.disabled = false
                  this.$set(item, 'checked', true)
                  this.getFoods(this.specialMenuType, item.ItemType)
                } else {
                  item.disabled = true
                  this.$set(item, 'checked', false)
                }
              } else {
                item.disabled = item.IsSpecial
                if (this.orderTypeId === 1) {
                  item.unAvailable = item.IsAvailableNow && item.CanBePickup ? false : true
                } else if (this.orderTypeId === 2) {
                  item.disabled = item.IsSpecial
                  item.unAvailable = !item.CanBeDinein
                } else if (this.orderTypeId === 3) {
                  item.disabled = item.IsAvailableNow && item.CanBeDelivered ? false : true
                }
              }
            })
            let enabled = this.menuTypes.filter(item => !item.disabled && !item.unAvailable).map(item => ({...item}))
            let unavailable = this.menuTypes.filter(item => !item.disabled && item.unAvailable).map(item => ({...item}))
            let disabled = this.menuTypes.filter(item => item.disabled).map(item => ({...item}))
            this.menuTypes = [...enabled, ...unavailable, ...disabled]
            
          } else {
            return this.$showError(res.message)
          }
          model.ItemType = "Drink"
          this.$api.getRestaurant
        .GetRestaurantMenuTypes(model)//get all the drinks after foods
        .then(res => {
          if (res.success) {
            this.foods = []
            this.food = null
            this.PriceType = null
            this.ItemCategory = null
            let tempMenuTypes= [...res.results.RestaurantMenuTypeAll.filter(item => item.CanMenuTypeBeShown)]
            tempMenuTypes.forEach((item, index) => {
              if (this.specialMenuType) {
                if (item.MenuTypeID === this.specialMenuType) {
                  item.disabled = false
                  this.$set(item, 'checked', true)
                  this.getFoods(this.specialMenuType, item.ItemType)
                } else {
                  item.disabled = true
                  this.$set(item, 'checked', false)
                }
              } else {
                item.disabled = item.IsSpecial
                if (this.orderTypeId === 1) {
                  item.unAvailable = item.IsAvailableNow && item.CanBePickup ? false : true
                } else if (this.orderTypeId === 2) {
                  item.disabled = item.IsSpecial
                  item.unAvailable = !item.CanBeDinein
                } else if (this.orderTypeId === 3) {
                  item.disabled = item.IsAvailableNow && item.CanBeDelivered ? false : true
                }
              }
            })
            let enabled = tempMenuTypes.filter(item => !item.disabled && !item.unAvailable).map(item => ({...item}))
            let unavailable = tempMenuTypes.filter(item => !item.disabled && item.unAvailable).map(item => ({...item}))
            let disabled = tempMenuTypes.filter(item => item.disabled).map(item => ({...item}))
            tempMenuTypes = [ ...enabled, ...unavailable,...disabled]
            
            if(tempMenuTypes.length === 0){
              this.menuTypes = [...this.menuTypes, ...tempMenuTypes]
            }else{
              let nullItem = {
                MenuType:"",
              disabled:true,
              unAvailable:true, 
            }//just a spacer between foods and drinks
              
              
              this.menuTypes = [...this.menuTypes, nullItem,... tempMenuTypes]

                    
            }
            this.menuTypes.forEach((item, index) => {
              if (index === 0 && !item.disabled) {
                this.$set(item, 'checked', true)
                // this.getFoods(item.MenuTypeID, this.ItemType)
                this.getCategories(item.MenuTypeID)
              }
            })
            
            // Update scroll reminder dots after menu types are loaded
            this.$nextTick(() => {
              this.updateScrollReminderDots()
            })
            
          } else {
            this.$showError(res.message)
          }
        })
        
        })
        .catch(() => {})
    },

    getCategories(menutype) {
      this.openItem = ""
      this.openItemButtonValue = ""
      this.showOpenItemChoices = false
      this.menuTypeId = menutype
      this.remainCount = ''
      let itemTypeOfSelectedMenu = ""
      this.menuTypes.forEach(i => {
        if (i.MenuTypeID === menutype) {
          itemTypeOfSelectedMenu = i.ItemType
          this.ItemType = i.itemType
          i.checked = true
        } else {
          i.checked = false
        }
      })
      return this.loadCategoriesWithFoods(menutype, itemTypeOfSelectedMenu).then(() => {
        this.categories = this.categoriesCache[menutype]
        this.categories.forEach((item, index) => {
          if (index === 0) {
            this.$set(item, 'selected', true)
            this.getAllFoods(item.CategoryID)
          } else {
            this.$set(item, 'selected', false)
          }
        })
        
        // Update category scroll reminder dots after categories are loaded
        this.$nextTick(() => {
          this.updateCategoryScrollReminderDots()
          // Re-setup scroll listener in case container was recreated
          this.setupCategoryScrollListener()
        })
      })
    },

    // Fetches all of a menu type's categories with their food/drink items
    // already nested inside, in a single request, and caches the result
    // (per MenuTypeID) so re-selecting the same menu/category doesn't
    // trigger new network requests. Pass forceRefresh to bypass the cache
    // when data needs to be re-synced with the server (e.g. after an order
    // changes stock/availability).
    loadCategoriesWithFoods(menutype, edibleType, forceRefresh = false) {
      if (this.categoriesCache[menutype] && !forceRefresh) {
        return Promise.resolve(this.categoriesCache[menutype])
      }
      const categoryPayload = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        MenuTypeID: menutype,
        EdibleType: edibleType
      }
      return this.$api.category.getCategoryWithFoodDrink(categoryPayload).then(res => {
        this.categoriesCache[menutype] = res.data.categories
        return this.categoriesCache[menutype]
      })
    },
    
    getAllFoods(CategoryID, forceRefresh = false) {
      this.selectedCategoryID = CategoryID
      let itemTypeOfSelectedMenu = ""
      this.menuTypes.forEach((i)=>{
        if(i.checked)
          itemTypeOfSelectedMenu = i.ItemType
        
      })
      this.ItemType = itemTypeOfSelectedMenu

      const applyFoods = () => {
        this.categories.forEach((i) => {
          i.selected = i.CategoryID === CategoryID
        })
        this.resetModifiers()
        this.ItemCategory = null
        this.PriceType = null
        const selectedCategory = this.categories.find(i => i.CategoryID === CategoryID)
        const categoryFoods = (selectedCategory && selectedCategory.FoodDrinks) || []
        const available = categoryFoods.filter(i => i.IsAvailable)
        const Notavailable = categoryFoods.filter(i => !i.IsAvailable)
        this.foods = [...available, ...Notavailable]
        this.foods.forEach(item => {
          this.$set(item, 'selected', false)
          item.value = item.ID
          item.ItemID = item.ID
          item.availablePrices = [
            {text: 'Price', value: item.Price, comment: item.PriceComment},
            {text: 'Price1', value: item.Price1, comment: item.Price1Comment},
            {text: 'Price2', value: item.Price2, comment: item.Price2Comment},
            {text: 'Price3', value: item.Price3, comment: item.Price3Comment},
            {text: 'Price4', value: item.Price4, comment: item.Price4Comment}
          ]
          item.name = item.Name

          if (this.addPlusSymbol(item)) {
            item.priceSymbol = '+ '
          } else {
            item.priceSymbol = ''
          }
          if (item.Price !== -999999) {
            item.PriceInfo =
              
              '$' +
              item.Price +
              item.priceSymbol +
              (item.IsAvailable ? '' : ' (Unavailable)')
          } else {
            item.PriceInfo = ' ' + item.priceSymbol + (item.IsAvailable ? '' : ' (Unavailable)')
          }
        })
        this.foods.sort(function(a, b){
            if(a.Name < b.Name) { return -1; }
            if(a.Name > b.Name) { return 1; }
            return 0;
        })
      }

      if (forceRefresh) {
        return this.loadCategoriesWithFoods(this.menuTypeId, itemTypeOfSelectedMenu, true).then(() => {
          this.categories = this.categoriesCache[this.menuTypeId]
          applyFoods()
        }).catch(() => {})
      }

      applyFoods()
      return Promise.resolve()
    },


    addPlusSymbol(item) {
      if (item.availablePrices.filter(i => i.value > 0).length > 1) {
        return true
      }
      if (item.HasModifier) {
        return true
      }
      return false
    },
    selectFood(food) {
      if (food) {
        this.ItemCategory = food
        this.foods.forEach(item => {
          if (item.ID === food.ID) {
            item.selected = true
          } else {
            item.selected = false
          }
        })
        
        this.selectPriceType()
        this.getItemAvailabilty(food)
        this.getAllModifiers(food)
        
        
      
      } else {
        this.foods.forEach(item => {
          item.selected = false
        })
        this.ItemCategory = null
        this.remainCount = ''
        this.PriceType = ''
      }
      
    },
    changeFood(food) {
      if (food) {
        this.selectPriceType()
        this.getItemAvailabilty(food)
        this.getAllModifiers(food)
        this.foods.forEach(item => {
          if (item.ID === food.ID) {
            item.selected = true
          } else {
            item.selected = false
          }
        })
      } else {
        this.foods.forEach(item => {
          item.selected = false
        })
        this.remainCount = ''
        this.PriceType = ''
      }
    },
    selectPriceType() {
      if (this.priceTypes.length) {
        this.PriceType = this.priceTypes[0].comment
      } else {
        this.PriceType = ''
      }
    },
    getAllModifiers(food) {
      if (food) {
        const model = {
          RestaurantID: this.$store.state.selectedRestaurantId,
          // UserID: localStorage.getItem('userID'),
          OrderID: this.selectedOrderID,
          FoodID: this.ItemType === 'Food' ? food.ItemID : 0,
          DrinkID: this.ItemType === 'Drink' ? food.ItemID : 0
        }
        return this.$api.getRestaurant.GetModifierByFoodID(model).then(res => {
          if (res.success) {
            let optional = res.results.filter(i => i.IsOptional)
            let required = res.results.filter(i => !i.IsOptional)
            this.modifiers = [...required, ...optional]
            let food = this.foods.find(i => i.selected === true)
           
            if(this.modifiers.length === 0 && food.Price1 == -1){// if item has no modifiers or price comments, add it without needing to press add item button
              return this.addItem()
            }
            this.modifiers.forEach((item, index) => {
              if (!item.IsOptional) {
                if (item.ChoiceOption === 'Exactly') {
                  item.errorText = 'Please select exactly ' + item.ChoiceNumber + ' items'
                  this.$set(item, 'hasError', true)
                } else if (item.ChoiceOption === 'Minimum') {
                  this.$set(item, 'hasError', true)
                  item.errorText = 'Please select Mininmum ' + item.ChoiceNumber + ' choices'
                } else if (item.ChoiceOption === 'Maximum') {
                  this.$set(item, 'hasError', true)
                  item.errorText = 'Please select Maximum ' + item.ChoiceNumber + ' choices'
                }
              } else {
                if (item.ChoiceOption === 'Exactly') {
                  item.errorText = ''
                  this.$set(item, 'hasError', false)
                } else if (item.ChoiceOption === 'Minimum') {
                  item.errorText = ''
                  this.$set(item, 'hasError', false)
                } else if (item.ChoiceOption === 'Maximum') {
                  item.errorText = ''
                  this.$set(item, 'hasError', false)
                }
              }
              if (index === 0) {
                this.$set(item, 'selected', true)
              } else {
                this.$set(item, 'selected', false)
              }
              item.ModifierItems.forEach(ch => {
                this.$set(ch, 'checked', false)
              })
            })
          } else {
            this.$showError(res.message)
          }
        })
      }
    },
    selectModifier(modifier) {
      this.modifiers.forEach(item => {
        item.selected = false
      })
      modifier.selected = true
      this.$nextTick(() => {
        this.setupModifierGroupScrollListener()
      })
    },
    resetModifiers() {
      this.modifiers = []
    },
    changeModifierOption(modifier, modifierGroup) {
      modifier.checked = !modifier.checked
      if (!modifierGroup.IsOptional) {
        //check at lease one modifier options
        let ChoiceNumber = modifierGroup.ChoiceNumber
        let ChoiceOption = modifierGroup.ChoiceOption
        if (ChoiceOption === 'Exactly') {
          let checkModifier = modifierGroup.ModifierItems.filter(i => i.checked)
          if (!checkModifier.length) {
            modifierGroup.errorText = 'Please select exactly ' + ChoiceNumber + ' items'
            modifierGroup.hasError = true
          } else {
            if (checkModifier.length !== +ChoiceNumber) {
              modifierGroup.errorText = 'Please select exactly ' + ChoiceNumber + ' items'
              modifierGroup.hasError = true
            } else {
              modifierGroup.errorText = ''
              modifierGroup.hasError = false
            }
          }
        } else if (ChoiceOption === 'Minimum') {
          let checkModifier = modifierGroup.ModifierItems.filter(i => i.checked)
          if (!checkModifier.length) {
            modifierGroup.errorText = 'Please select Mininmum ' + ChoiceNumber + ' choices'
            modifierGroup.hasError = true
          } else {
            if (checkModifier.length < +ChoiceNumber) {
              modifierGroup.errorText = 'Please select Mininmum ' + ChoiceNumber + ' choices'
              modifierGroup.hasError = true
            } else {
              modifierGroup.errorText = ''
              modifierGroup.hasError = false
            }
          }
        } else if (ChoiceOption === 'Maximum') {
          let checkModifier = modifierGroup.ModifierItems.filter(i => i.checked)
          if (!checkModifier.length) {
            modifierGroup.errorText = 'Please select Maximum ' + ChoiceNumber + ' choices'
            modifierGroup.hasError = true
          } else {
            if (checkModifier.length > +ChoiceNumber) {
              modifierGroup.errorText = 'Please select Maximum ' + ChoiceNumber + ' choices'
              modifierGroup.hasError = true
            } else {
              modifierGroup.errorText = ''
              modifierGroup.hasError = false
            }
          }
        }
      } else {
        let ChoiceNumber = modifierGroup.ChoiceNumber
        let ChoiceOption = modifierGroup.ChoiceOption
        if (ChoiceOption === 'Exactly') {
          let checkModifier = modifierGroup.ModifierItems.filter(i => i.checked)
          if (!checkModifier.length) {
            modifierGroup.errorText = ''
            modifierGroup.hasError = false
          } else {
            if (checkModifier.length !== +ChoiceNumber) {
              modifierGroup.errorText = 'Please select exactly ' + ChoiceNumber + ' items'
              modifierGroup.hasError = true
            } else {
              modifierGroup.errorText = ''
              modifierGroup.hasError = false
            }
          }
        }
      }
    },
    getItemAvailabilty(food) {
      const model = {
        // UserID: localStorage.getItem('userID'),
        RestaurantID: this.$store.state.selectedRestaurantId,
        ItemType: this.ItemType,
        ItemID: food.ItemID
      }
      return this.$api.getRestaurant.GetItemAvailability(model).then(res => {
        if (res.success) {
          let results = res.results
          if (results.Total_Remain) {
            if (+results.Total_Remain < 0) {
              this.remainCount = '0'
            } else {
              if (this.selectedItems && this.selectedItems.length) {
                const findItem = this.selectedItems.filter(i => food.ItemID === i.ItemID)
                if (findItem.length) {
                  this.remainCount = (results.Total_Remain - this.totalQty(findItem)).toString()
                } else {
                  this.remainCount = results.Total_Remain
                }
              } else {
                this.remainCount = results.Total_Remain
              }
            }
          } else {
            this.remainCount = ''
          }
        }
      })
    },
    totalQty(items) {
      return items.reduce(function(acc, current) {
        return Number(acc) + Number(current.Qty)
      }, 0)
    },
    isAlcoholicOpen() {},
    resetOpenItem() {
      this.selectedOpenItemName = ""
      this.openItemUnitPrice = ""
    },
    addItem() {
      this.$validator.validateAll().then(proceed => {
        if (proceed) {

          let ModifierIDs = []
          let ModifierNames = []
          let ModifierNamesSecondLang = []
          this.modifiers.forEach(item => {
            item.ModifierItems.forEach(ch => {
              if (ch.checked) {
                ModifierIDs.push(ch.ModifierID)
                ModifierNames.push(ch.ModifierName)
                if(ch.ModifierName_SecondLang != ""){
                    ModifierNamesSecondLang.push(ch.ModifierName_SecondLang)
                }else{
                    ModifierNamesSecondLang.push(ch.ModifierName)
                } 
              }
            })
          })
          
          let model = {}
          if (this.openItem === 'open') {
            model = {
              IKey: 0,
              RestaurantID: this.$store.state.selectedRestaurantId,
              // UserID: localStorage.getItem('userID'),
              OrderID: !this.selectedOrderID ? 0 : this.selectedOrderID,
              FoodId: this.openItemType === 'Food' ? this.OpenItemCategory.ItemID : 0,
              DrinkID: this.openItemType === 'Drink' ? this.OpenItemCategory.ItemID : 0,
              Qty: this.Quantity,
              PriceType: this.openItemUnitPrice,
              PriceTypeValue: '',
              DetailDescription:  this.selectedOpenItemName + ' ' + this.Description,
              ModifierIDs: '',
              ModifierNames: '',
              Name: this.OpenItemCategory.ItemName,
              ItemName_SecondLang: '',
              PriceComment: '',
              ItemID: this.OpenItemCategory.ItemID,
              Alcoholic: this.OpenItemCategory.ItemName.includes('Drink Item (Alcoholic)') ? true : false,
              SelectedMenuType: '',
              Price: this.openItemUnitPrice,
              ItemType: this.ItemType,
              totalPrice: (this.openItemUnitPrice * this.Quantity).toFixed(2),
              open: true,
              CourseNo: this.orderTypeId === 2 && this.CourseNo ? 'C' + this.CourseNo : '',
              KDS: this.KDS,
              PrinterID: this.PrinterID
            }
            this.resetOpenItem()
          } else {
            model = {
              IKey: 0, 
              
              RestaurantID: this.$store.state.selectedRestaurantId,
              OrderID: !this.selectedOrderID ? 0 : this.selectedOrderID,
              FoodId: this.ItemType === 'Food' ? this.ItemCategory.ItemID : 0,
              DrinkID: this.ItemType === 'Drink' ? this.ItemCategory.ItemID : 0,
              Qty: this.Quantity,
              
              PriceType: this.findPriceField(this.priceTypes),
              PriceTypeValue: this.findPriceValue(this.priceTypes),
              PriceComment: this.findPriceComment(this.priceTypes),
              PriceComment_SecondLang: this.findPriceCommentSecondLang(this.priceTypes),
              
              DetailDescription: this.Description,
              ModifierIDs: ModifierIDs.length ? '#' + ModifierIDs.join('#') : '',
              ModifierNames: ModifierNames.length ? ModifierNames.join(',') : '',
              ModifierNamesSecondLang: ModifierNamesSecondLang.length ? ModifierNamesSecondLang.join(',') : '',
              Name: this.ItemCategory.Name,
              ItemName_SecondLang: this.ItemCategory.Name_SecondLang,
              ItemID: this.ItemCategory.ItemID,
              Alcoholic: this.ItemCategory.Alcoholic,
              SelectedMenuType: this.menuTypeId,
              Price: this.ItemCategory.Price,
              ItemType: this.ItemType,
              totalPrice: this.totalPrice().toFixed(2),
              open: false,
              CourseNo: this.orderTypeId === 2 && this.CourseNo ? 'C' + this.CourseNo : '',
              KDS: -1,
              PrinterID: -1
            }
          }
          this.Description = ''
          this.Quantity = 1
          this.$emit('addItemFinaly', model)
          
          //this.getCategories(this.menuTypes[0].MenuTypeID)
          this.getAllFoods(this.selectedCategoryID, true)
        }
      })
    },
    findPriceCommentSecondLang(types){
        var i = 0 
        var foundIndex = 0

        types.forEach(el=>{
          if(el.comment == this.PriceType){
              foundIndex = i
          }
          i++
        })


        if(foundIndex == 0){
          return this.ItemCategory.PriceComment_SecondLang
        }
        if(foundIndex == 1){
          return this.ItemCategory.Price1Comment_SecondLang
        }
        if(foundIndex == 2){
          return this.ItemCategory.Price2Comment_SecondLang
        }
        if(foundIndex == 3){
          return this.ItemCategory.Price3Comment_SecondLang
        }

        
        
      
    },
    addItemAndUpdateAddedItem() {
      this.$validator.validateAll().then(proceed => {
        if (proceed) {
          let ModifierIDs = []
          let ModifierNames = []
          this.modifiers.forEach(item => {
            item.ModifierItems.forEach(ch => {
              if (ch.checked) {
                ModifierIDs.push(ch.ModifierID)
                ModifierNames.push(ch.ModifierName)
              }
            })
          })
          let model = {}
          if (this.openItem === 'open') {
            model = {
              IKey: 0,
              RestaurantID: this.$store.state.selectedRestaurantId,
              // UserID: localStorage.getItem('userID'),
              OrderID: !this.selectedOrderID ? 0 : this.selectedOrderID,
              FoodId: this.ItemType === 'Food' ? this.OpenItemCategory.ItemID : 0,
              DrinkID: this.ItemType === 'Drink' ? this.OpenItemCategory.ItemID : 0,
              Qty: this.Quantity,
              PriceType: this.openItemUnitPrice,
              PriceTypeValue: '',
              DetailDescription: this.Description,
              ModifierIDs: '',
              ModifierNames: '',
              Name: this.OpenItemCategory.ItemName,
              ItemName_SecondLang: '',
              PriceComment: '',
              ItemID: this.OpenItemCategory.ItemID,
              Alcoholic: this.OpenItemCategory.ItemName.includes('Alcoholic') ? true : false,
              SelectedMenuType: '',
              Price: this.openItemUnitPrice,
              ItemType: this.ItemType,
              totalPrice: (this.openItemUnitPrice * this.Quantity).toFixed(2),
              open: true,
              CourseNo: this.orderTypeId === 2 && this.CourseNo ? 'C' + this.CourseNo : '',
              KDS: this.KDS,
              PrinterID: this.PrinterID
            }
          } else {
            model = {
              IKey: 0,
              RestaurantID: this.$store.state.selectedRestaurantId,
              // UserID: localStorage.getItem('userID'),
              OrderID: !this.selectedOrderID ? 0 : this.selectedOrderID,
              FoodId: this.ItemType === 'Food' ? this.ItemCategory.ItemID : 0,
              DrinkID: this.ItemType === 'Drink' ? this.ItemCategory.ItemID : 0,
              Qty: this.Quantity,
              
              PriceType: this.findPriceField(this.priceTypes),
              PriceTypeValue: this.findPriceValue(this.priceTypes),
              PriceComment: this.findPriceComment(this.priceTypes),
              PriceComment_SecondLang: this.findPriceCommentSecondLang(this.priceTypes),
              
              DetailDescription: this.Description,
              ModifierIDs: ModifierIDs.length ? '#' + ModifierIDs.join('#') : '',
              ModifierNames: ModifierNames.length ? ModifierNames.join(',') : '',
              Name: this.ItemCategory.ItemName,
              ItemName_SecondLang: this.ItemCategory.ItemName_SecondLang,
              ItemID: this.ItemCategory.ItemID,
              Alcoholic: this.ItemCategory.Alcoholic,
              SelectedMenuType: this.menuTypeId,
              Price: this.ItemCategory.Price,
              ItemType: this.ItemType,
              totalPrice: this.totalPrice().toFixed(2),
              open: false,
              CourseNo: this.orderTypeId === 2 && this.CourseNo ? 'C' + this.CourseNo : '',
              KDS: -1,
              PrinterID: -1
            }
          }

          this.$emit('addItemWithUpdateOrderStatus', model)
        }
      })
    },
    findPriceComment(prices) {
      const find = prices.find(item => item.comment == this.PriceType)
      return find ? find.comment : ''
    },
    findPriceField(prices) {
      const find = prices.find(item => item.comment == this.PriceType)
      return find ? find.text : ''
    },
    findPriceValue(prices) {
      const find = prices.find(item => item.comment == this.PriceType)
      return find ? find.value : ''
    },
    
    cancel() {
      this.$emit('cancelAddItem', false)
    },
    priceSelectedModifiers() {
      let modifierOptions = []
      this.modifiers.forEach(item => {
        item.ModifierItems.forEach(ch => {
          if (ch.checked) {
            modifierOptions.push(ch)
          }
        })
      })
      // Price
      return modifierOptions.reduce(function(acc, current) {
        return Number(acc) + Number(current.Price)
      }, 0)
    },
    totalPrice() {
      return (this.findPriceValue(this.priceTypes) + this.priceSelectedModifiers()) * this.Quantity
    }
  }
}
</script>
<style scoped lang="scss">

.veggie-item-name {
  background-color: #AED581;
  display: inline;
  padding: 0 0.15rem;
  border-radius: 2px;
}

.menu-types-grid{
  gap: 1rem ;
  height: 6rem !important;
 
}
.menu-types-grid::-webkit-scrollbar {
  display: none;
}

.groupsButtons {
  .disabled {
    background: #fff !important;
    border-color: #c4c9ce !important;
    color: #c4c9ce !important;
  }
}
.menu-types-width{
  max-height: 2.5rem;
  width: fit-content;
}
.activeBtn {
  background: #f5c31d !important;
  border-color: #464b50 !important;
}
.activeBtnDrink{
  background: #81D4FA !important;
  border-color: #464b50 !important;
}
.activeDrinkBtn{
  background: #81D4FA !important;
  border-color: #464b50 !important;

}


.unavailable-item {
  
  background-color: #fff;
  background-image: linear-gradient(30deg, #a8a8a8 3.85%, #ffffff 3.85%, #ffffff 50%, #a8a8a8 50%, #a8a8a8 53.85%, #ffffff 53.85%, #ffffff 100%);
background-size: 26.00px 15.01px;
  z-index: 2;
  border: 1px solid #464b50;
  
  
}
.deactiveBtn,
.available {
  background: #fff !important;
  border-color: #464b50 !important;
  color: #464b50 !important;
}
.availableCategoryBtn{
  background: #78909c !important;
  border-color: #464b50 !important;
  color: white !important;
}
.availableDrinks{
  background: #fff !important;
  color:#1565C0  !important;

  border-color: #1565C0;
}
.unavailable {
  background: #fff !important;
  border-color: #c4c9ce !important;
  color: #c4c9ce !important;
}
.remove-scroll-bar::-webkit-scrollbar {
  display: none !important;
}
.groupsButtons::-webkit-scrollbar {
  display: none !important;
}
.groupsButtons {
  scrollbar-width: none !important;
}
select {
  option {
    span#itemName {
      font-weight: bold !important;
      color: red !important;
    }
  }
}
.error-btn-animated {
  animation: opacity 1.75s infinite;
  animation-fill-mode: forwards;
  color: #F86C6B !important;
  font-weight: bold !important;
}
.food-type-food-button {
  color: #F5C31C !important;
  border: 1px solid #F5C31C !important;
  background: #fff !important;
  transition: background 0.15s, color 0.15s;
}
.food-type-food-button:focus, 
.food-type-food-button:active, 
.food-type-food-button.active, 
.food-type-food-button:checked, 
.food-type-food-button:hover {
  background: #F5C31C !important;
  border: 1px solid #F5C31C !important;
  color: #111 !important;
  box-shadow: none;
}



.menu-types{
  display: flex;
  justify-content: space-between;
  align-content: center;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
  overflow-x: scroll;
}
.open-item-toggle{
  width: 10rem;
  height: 2.75rem;
  font-weight: bold;
  border-radius: 0.35rem;
}
.open-choice-btn{
  min-width: 10rem;
  height: 2.75rem;
  font-weight: bold;
  border-radius: 1rem;
}
.drink-open-choice{
  color: #1565C0 !important;
  background: #fff !important;
  border: 1px solid #1565C0 !important;
}
.drink-open-choice:focus,
.drink-open-choice:active,
.drink-open-choice.active,
.drink-open-choice:hover{
  color: #111 !important;
  background: #81D4FA !important;
  border: 1px solid #1565C0 !important;
  box-shadow: none;
}
/* Replace scroll bar with three dot icons for menu-types scroll hint */
.menu-types::-webkit-scrollbar {
  display: none !important;
}

.menu-types {
  scrollbar-width: none !important;
  position: relative;
}

.food-item-container::-webkit-scrollbar {
  display: none;
}
.food-items-wrapper {
  position: relative;
  padding-bottom: 1.5rem;
}
.food-scroll-reminder {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  z-index: 5;
}

.section-title {
  color: #000;
  font-weight: bold;
}
.item-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}
.item-tag {
  font-size: 0.8rem;
  font-weight: bold;
  padding: 0.15rem 0.5rem;
  border-radius: 25px;
}

/* modifier groups: one column, scrolls vertically, dots on the right */
.modifier-groups-wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}
.modifier-groups-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 11rem;
  max-height: 15.5rem;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
}
.modifier-groups-container::-webkit-scrollbar {
  display: none;
}
.modifier-group-btn {
  flex-shrink: 0;
  width: 100%;
  min-height: 3.5rem;
  border-radius: 25px !important;
  font-weight: bold;
  white-space: normal;
}
.modifier-group-btn.modifier-group-btn-error {
  border: 2px solid #F86C6B !important;
}
.modifier-error-highlight {
  background-color: yellow;
  padding: 0.1rem 0.5rem;
  border-radius: 4px;
}
.modifier-groups-scroll-reminder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.modifier-groups-scroll-reminder .scroll-dot-first {
  width: 12px;
  height: 28px;
}

.modifier-error-text {
  color: #F86C6B;
  background-color: yellow;
  font-weight: bold;
  padding: 0.1rem 0.75rem;
  border-radius: 4px;
}

/* modifier options: List View style cards that wrap horizontally */
.modifier-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.modifier-option {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  min-width: 10rem;
  max-width: 100%;
  padding: 0.5rem 0.75rem;
  background: #fff;
  border: 1px solid #c4c9ce;
  border-radius: 8px;
  color: #000;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}
.modifier-option:focus {
  outline: none;
}
.modifier-option.checked {
  border-color: #f5c31d;
  background: #fff8e1;
  box-shadow: 0 0 0 1px #f5c31d;
}
.modifier-option-check {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.4rem;
  height: 1.4rem;
  border: 1px solid #9e9e9e;
  border-radius: 4px;
  background: #fff;
  color: #000;
  font-size: 0.8rem;
}
.modifier-option.checked .modifier-option-check {
  background: #f5c31d;
  border-color: #f5c31d;
}
.modifier-option-text {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}
.modifier-option-name {
  font-size: 1.05rem;
}
.modifier-option-desc {
  font-size: 0.8rem;
  font-style: italic;
  color: #6c757d;
}
.modifier-option-price {
  font-size: 0.85rem;
  font-weight: bold;
}

@keyframes color {
  from {
    color: #fff;
  }
  to {
    color: #000;
  }
}

/* Scroll reminder dots styling */
.scroll-dot {
  cursor: pointer;
  user-select: none;
  border-radius: 50%;
  display: inline-block;
  transition: all 0.3s ease;
  font-size: 1.2rem;
  font-weight: bold;
}

.scroll-dot-first {
  width: 28px;
  height: 12px;
  border-radius: 14px; /* Makes it a flat oval */
}

.scroll-dot:not(.scroll-dot-first) {
  width: 12px;
  height: 12px;
  border-radius: 50%; /* Regular circular dots */
}

.scroll-dot-active {
  background-color: #ffc108 !important;
  transform: scale(1.2);
  box-shadow: 0 0 8px rgba(255, 193, 8, 0.5);
}

.scroll-dot-inactive {
  background-color: #6c757d !important;
  opacity: 0.6;
  transform: scale(1);
}

.scroll-dot:hover {
  transform: scale(1.1);
  opacity: 0.8;
}

.scroll-dot-first.scroll-dot-active {
  transform: scale(1.1); /* Slightly less scale for the wider first dot */
}

.scroll-dot-first.scroll-dot-inactive {
  transform: scale(1);
}
.lastItem {
  border-top-right-radius: 25px!important;
  border-bottom-right-radius: 25px!important;
}
.firstItem {
  border-top-left-radius: 25px!important;
  border-bottom-left-radius: 25px!important;
  }
.input-group-text {
  font-size: 1.1rem !important;
}


</style>
